module.exports = __webpack_public_path__ + "img/toolbar-bg-main.29bf35da.jpg";